import React from 'react';

import { Row } from './styles';

type VirtualRowProps = {
  rowKey: string;
  observer: ResizeObserver | null;
  children: React.ReactNode;
};

const VirtualRow: React.FC<VirtualRowProps> = ({ rowKey, observer, children }) => {
  const ref = React.useRef<HTMLDivElement>(null);

  React.useLayoutEffect(() => {
    const element = ref.current;
    if (!element || !observer) {
      return undefined;
    }
    observer.observe(element);
    return () => observer.unobserve(element);
  }, [observer]);

  return (
    <Row ref={ref} data-row-key={rowKey}>
      {children}
    </Row>
  );
};

export default VirtualRow;
